import React, { Component } from "react";
import { Modal } from "antd";
import "antd/lib/modal/style";
import "./VhPreview.scss";

interface PropsOwn {
  /**
   * 弹层是否显示
   */
  visible: boolean;
  /**
   * 要预览的图片地址
   */
  imgUrl: string;
  /**
   * 关闭弹层回调
   */
  onClose: () => void;
}

// 合并类型
type AllProps = PropsOwn;

/**
 * 图片预览组件
 *
 * @class VhPreview
 * @extends {Component<AllProps>}
 */
class VhPreview extends Component<AllProps> {
  /**
   * 渲染
   *
   * @returns
   * @memberof VhPreview
   */
  public render() {
    return (
      <Modal
        wrapClassName="preview-container"
        visible={ this.props.visible }
        width={ 800 }
        footer={ null }
        closable={ false }
        destroyOnClose={ true }
        centered={ true }
        onCancel={ this.props.onClose }
      >
        <img
          style={ {maxWidth: "100%", maxHeight: "100%"} }
          alt="无图片"
          src={ this.props.imgUrl }
        />
      </Modal>
    );
  }
}

export default VhPreview;
